import { RENDER_WEBSITE_PAGE, SET_WEBSITE_MENUS } from "../action-types/app";

const initialState = {
    url: "",
    menus: []
};

const appReducer = (state = initialState, action) => {
    switch(action.type) {
        case RENDER_WEBSITE_PAGE:
            return {
                ...state,
                url: action.url
            };
        case SET_WEBSITE_MENUS:
            return {
                ...state,
                menus: action.menus
            };
        default:
            return state;
    }
}

export default appReducer;